import { App } from '@/components/App.tsx';
import {
  setMiniAppHeaderColor,
  themeParams,
  useSignal
} from "@telegram-apps/sdk-react";
import {mixHexColors} from "@/helpers/mixHexColors.ts";
import {datadogLogs} from "@datadog/browser-logs";

export function Root() {
  const bgColor = useSignal(themeParams.backgroundColor);
  const secondaryBgColor = useSignal(themeParams.secondaryBackgroundColor);
  if (bgColor && secondaryBgColor && (bgColor === secondaryBgColor)) {
    const bgSectionColor = window.getComputedStyle(document.documentElement).getPropertyValue('--tg-theme-section-bg-color');
    const mixedSecondaryColor = mixHexColors(bgSectionColor, bgColor);
    document.documentElement.style.setProperty('--tg-theme-secondary-bg-color', mixedSecondaryColor);
    // @ts-expect-error it works
    setMiniAppHeaderColor(mixedSecondaryColor);
  }

  datadogLogs.init({
    clientToken: import.meta.env.MODE !== 'development' ?
      'pub09af652262f32023f475afc61e1e7d12' :
      '',
    // clientToken: 'pub09af652262f32023f475afc61e1e7d12',
    service: 'react-wishapp',
    site: 'datadoghq.eu',
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['error'],
    sessionSampleRate: 100,
    sessionPersistence: ['cookie', 'local-storage', 'memory'],
    beforeSend: (event, context) => {
      if (event.http?.url?.replace(/[?#].*$/, '').endsWith('/api/health')) {
        return false;
      }

      if (event.error || ['error', 'critical', 'alert', 'emerg'].includes(event.status)) {
        event.error_origin = {
          source: event.origin,
          message: event.message,
          http: event.http,
          is_aborted: context && 'isAborted' in context ? context.isAborted : undefined,
          handling_stack: context?.handlingStack,
          error: event.error,
          axios_error: event.axios_error,
        };
      }

      if (event.message) {
        if (
          event.message.includes("DialogTitle") ||
          event.message.includes("google-analytics")
        ) {
          return false;
        }
      }

      return true;
    },
  })

  return (
    <div id="wrap">
      <div id="content" className={'pb-10'}>
        <App/>
      </div>
    </div>
  );
}
